/**
 * Sysadmin Audit — parent layout (Wave 3 §10.2 #5 / spec §3.6).
 */

import { createFileRoute, Link, Outlet, useLocation } from '@tanstack/react-router';
import { Activity, Link2, ShieldCheck, Download, Eye } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

export const Route = createFileRoute('/sysadmin/audit')({
  component: AuditLayout,
});

const SUB_TABS = [
  { key: 'stream',    label: 'Activity Stream', icon: Activity,    to: '/sysadmin/audit/stream',    status: 'v1' },
  { key: 'integrity', label: 'Chain Integrity', icon: Link2,       to: '/sysadmin/audit/integrity', status: 'v1' },
  { key: 'sysadmin',  label: 'Sysadmin Actions', icon: ShieldCheck, to: '/sysadmin/audit/sysadmin',  status: 'v1' },
  { key: 'exports',   label: 'Exports',         icon: Download,    to: '/sysadmin/audit/exports',   status: 'v1' },
  { key: 'witness',   label: 'Witness',         icon: Eye,         to: '/sysadmin/audit/witness',   status: 'v1' },
] as const;

function AuditLayout() {
  const location = useLocation();

  return (
    <div className="flex flex-col h-full">
      <div className="border-b sticky top-0 bg-background z-10">
        <nav className="flex items-center gap-0.5 overflow-x-auto px-6">
          {SUB_TABS.map((t) => {
            const Icon = t.icon;
            const active = location.pathname === t.to ||
              location.pathname.startsWith(t.to + '/');
            return (
              <Link
                key={t.key}
                to={t.to}
                className={cn(
                  'flex items-center gap-2 px-3 py-2 text-sm font-medium border-b-2 transition-colors whitespace-nowrap',
                  active
                    ? 'border-primary text-foreground'
                    : 'border-transparent text-muted-foreground hover:text-foreground',
                )}
              >
                <Icon className="h-4 w-4" />
                {t.label}
                {t.status !== 'v1' && (
                  <Badge variant="secondary" className="ml-1 text-[10px]">
                    {t.status}
                  </Badge>
                )}
              </Link>
            );
          })}
        </nav>
      </div>

      <div className="flex-1 overflow-y-auto">
        <Outlet />
      </div>
    </div>
  );
}
